import React from 'react';
import styled from 'styled-components';

const TitleContainer = styled.div`
  text-align: center;
  margin: 0 auto;
  max-width: 800px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  /* Responsividade para o container */
  @media (max-width: 768px) {
    max-width: 100%;
    padding: 15px;
    gap: 15px;
  }
`;

const Tecneps = styled.h1`
  font-weight: 900;
  font-family: Public Sans;
  font-size: 70px;
  color: #6AB8A8;
  margin: 0;

  @media (max-width: 1024px) {
    font-size: 60px;
    margin-top: 100px;
  }
  
  @media (max-width: 768px) {
    font-size: 48px; /* Mobile landscape */
  }
`;

const Subtitle = styled.h1`
  font-size: 18px;
  line-height: 1.2;
  font-family: Public Sans;
  font-weight: 800;
  color: #6AB8A8;
  margin: 0;
  text-align: center;
`;

const ModuleTitle = styled.h1`
  font-size: 24px;
  font-weight: bold;
  font-family: Public Sans;
  color: #FF9F1F;
  border: 2px solid #FF9F1F;
  border-radius: 10px;
  padding: 10px 40px;
  margin: 0;
  text-align: center;
  width: fit-content;

  @media (max-width: 1024px) {
    font-size: 22px; /* Tablets */
    padding: 10px 35px;
  }
  
  @media (max-width: 768px) {
    font-size: 16px; /* Mobile landscape */
    padding: 6px 20px;
    border-radius: 8px;
  }
`;

const TitleModule = () => {
  return (
    <TitleContainer>
      <Tecneps>TECNEPS</Tecneps>
      <Subtitle>
        Tecnologia de Gestão para Núcleos
        <br />
        de Educação Permanente em Saúde
      </Subtitle>
      <ModuleTitle>MÓDULO ATIVIDADES PRÁTICAS / ESTÁGIOS</ModuleTitle>
    </TitleContainer>
  );
};

export default TitleModule;